import React from "react";
//import ColorBends from "./ColorBends";
import img from "../assets/img.png";
const HeaderSection2 = () => {
    return (
        <div
            className="relative w-full h-screen bg-cover bg-bottom md:bg-center bg-scroll md:bg-fixed bg-no-repeat overflow-hidden flex flex-col justify-center items-center"
            style={{ backgroundImage: `url(${img})` }}
        >
            <div className="relative z-10 w-full px-4">
                <div className="flex flex-col gap-5 lg:gap-9 xl:w-4/5 w-full mx-auto lg:items-center items-start lg:justify-center justify-start 2xl:px-16">
                    <p className="font-extrabold lg:text-center text-start font-archivo text-white tracking-widest
                        text-4xl sm:text-5xl md:text-5xl lg:text-6xl xl:text-8xl
                        leading-snug lg:leading-[4rem] xl:leading-[6rem]">
                        La plateforme où les événements prennent vie
                    </p>

                    <p className="font-semibold text-white tracking-widest font-archivo
                        text-lg sm:text-xl lg:text-3xl
                        lg:text-center text-start leading-relaxed opacity-90">
                        Créez, partagez et vibrez avec les meilleurs événements près de chez vous.
                    </p>
                </div>
            </div>
        </div>
    );
};
export default HeaderSection2;

 